import EmployeeList from './Pages/EmployeeList';
import './App.css';

function App() {
  return (
    <EmployeeList />
  );
}

export default App;